<template>
  <v-select
    v-model="params[type]"
    @change="applyFilter"
    :items="items"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :loading="loading"
    :multiple="multiple"
    single-line
    clearable
    outlined
    small
    dense
  />
</template>

<script>
import { mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterSelect',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    items: {
      type: Array,
      require: true,
    },

    label: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      required: true,
    },

    itemText: {
      type: String | Function,
      default: 'text',
    },

    itemValue: {
      type: String | Function,
      default: 'value',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      params: {},
    }
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    applyFilter() {
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...this.params })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchData())
    },
  },
}
</script>
